import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EpicService {

  private epicBaseUrl = environment.epicApiUrl;

  constructor(private http: HttpClient) { }

  searchPatients(
    given: string,
    family: string,
    birthdate?: string,
    address?: string,
    telecom?: string,
    legalSex?:string
  ): Observable<any> {
    let params = new HttpParams()
      .set('given', given)
      .set('family', family);

    if (birthdate) {
      params = params.set('birthdate', birthdate);
    }
    if (address) {
      params = params.set('address', address);
    }
    if (telecom) {
      params = params.set('telecom', telecom);
    }
    if (legalSex) {
      params = params.set('legal-sex', legalSex);
    }

    return this.http.get(`${this.epicBaseUrl}/patient/search`, { params });
  }

  searchProviders(name: string): Observable<any> {
    const params = new HttpParams().set('name', name);
    return this.http.get(`${this.epicBaseUrl}/practitioner/search`, { params });
  }
}
